import React, { SVGProps } from 'react';

function UserGroup(props: SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M4.8125 8.4375C4.8125 9.34918 5.17466 10.2235 5.81932 10.8682C6.46398 11.5128 7.33832 11.875 8.25 11.875C9.16168 11.875 10.036 11.5128 10.6807 10.8682C11.3253 10.2235 11.6875 9.34918 11.6875 8.4375C11.6875 7.52582 11.3253 6.65148 10.6807 6.00682C10.036 5.36216 9.16168 5 8.25 5C7.33832 5 6.46398 5.36216 5.81932 6.00682C5.17466 6.65148 4.8125 7.52582 4.8125 8.4375V8.4375Z"
        fill="transparent"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M2.625 18.875C2.625 17.3832 3.21763 15.9524 4.27252 14.8975C5.32742 13.8426 6.75816 13.25 8.25 13.25C9.74184 13.25 11.1726 13.8426 12.2275 14.8975C13.2824 15.9524 13.875 17.3832 13.875 18.875"
        fill="transparent"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M13.96 9.8125C13.96 10.5584 14.2563 11.2738 14.7837 11.8012C15.3112 12.3287 16.0265 12.625 16.7725 12.625C17.5184 12.625 18.2338 12.3287 18.7612 11.8012C19.2886 11.2738 19.585 10.5584 19.585 9.8125C19.585 9.06658 19.2886 8.35121 18.7612 7.82376C18.2338 7.29632 17.5184 7 16.7725 7C16.0265 7 15.3112 7.29632 14.7837 7.82376C14.2563 8.35121 13.96 9.06658 13.96 9.8125V9.8125Z"
        fill="transparent"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M15.1775 14.5567C15.8734 14.3002 16.621 14.2156 17.3566 14.3101C18.0922 14.4046 18.7941 14.6753 19.4026 15.0993C20.0111 15.5233 20.5082 16.088 20.8516 16.7454C21.195 17.4028 21.3746 18.1334 21.375 18.875"
        fill="transparent"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

UserGroup.displayName = 'UserGroup';

export default UserGroup;
